import { formatCurrency } from '@utils/formatters';
import { TFunction } from 'i18next';
import { IEditableTableColumns } from '@components/EditableTable';

export const getModelDataColumns = (t: any) => {
  const columns: IEditableTableColumns[] = [
    {
      dataIndex: 'customerId',
      editable: true,
    },
    {
      dataIndex: 'invoiceId',
      editable: true,
    },
    {
      dataIndex: 'description',
      editable: true,
    },
    {
      dataIndex: 'quantity',
      editable: true,
      itemInputType: 'input-number',
      inputNumberProps: {
        step: 1,
        min: 0,
      },
    },
    {
      dataIndex: 'value',
      editable: true,
      itemInputType: 'input-number',
      inputNumberProps: {
        step: 0.5,
        addonBefore: 'R$',
      },
    },
    {
      dataIndex: 'totalValue',
      render: (_: any, record: any) => {
        const { quantity, value } = record;
        const totalValue = quantity && value ? quantity * value : 0;
        return formatCurrency(totalValue);
      },
    },
  ];
  return columns?.map(col => ({
    ...col,
    key: col.dataIndex,
    title: t(`items-modal.model-columns.${col.dataIndex}`),
  }));
};

export const getModelData = (t: TFunction) => [
  {
    key: '1',
    invoiceId: '0',
    customerId: 0,
    description: t('items-modal.model-columns.dsPlaceholder'),
    quantity: 1,
    value: 0,
    totalValue: 0,
  },
];
